import classNames from "classnames";
import { CurrenciesConfig, Currency } from "utils/formatter";
import CurrencyInput, { CurrencyInputProps } from "react-currency-input-field";
import "./baseCurrencyInput.scss";

interface IBaseCurrencyInputProps {
    currency: Currency;
    label?: string;
    value?: number;
    disabled?: boolean;
    onValueChange: (value: number | null | undefined, name: string) => void;
    name?: string;
    invalid?: string | undefined | boolean;
    withCode?: boolean;
    withSymbol?: boolean;
    alignLeft?: boolean;
    defaultValue?: number;
}

const BaseCurrencyInput = ({
    currency,
    value,
    onValueChange,
    label,
    invalid,
    name,
    defaultValue,
    alignLeft = true,
    withCode = true,
    withSymbol = true,
    disabled = false,
}: IBaseCurrencyInputProps) => {
    const currencyConfig = CurrenciesConfig.find(currencyConfig => currencyConfig.code === currency)!;

    const handleCurrencyValueChange: CurrencyInputProps["onValueChange"] = (_value, name, _values) => {
        onValueChange(_values?.float, name!);
    };

    return (
        <div>
            <div className={classNames("currency-input")}>
                <CurrencyInput
                    id={name}
                    name={name}
                    value={value}
                    decimalsLimit={currencyConfig.decimalLimit}
                    allowDecimals={currencyConfig.decimalLimit > 0}
                    onValueChange={handleCurrencyValueChange}
                    className={classNames(
                        "currency-input--input",
                        { "currency-input--input__align-right": !alignLeft },
                        { "currency-input--input__with-symbol": withSymbol && !withCode },
                        { "currency-input--input__with-code": !withSymbol && withCode },
                        { "currency-input--input__with-code-symbol": withCode && withSymbol }
                    )}
                    decimalSeparator=","
                    groupSeparator="."
                    // limit number of characters user can input because of an issue with large numbers
                    placeholder=" "
                    maxLength={16}
                    defaultValue={defaultValue}
                    disabled={disabled}
                />

                <label
                    className={classNames("currency-input--label", {
                        "currency-input--label__with-code": withCode,
                    })}
                >
                    {label}
                </label>

                {withCode && <div className="currency-input--prefix">{currencyConfig?.code}</div>}

                {withSymbol && <div className="currency-input--suffix">{currencyConfig?.symbol}</div>}
            </div>

            {invalid && <p className="currency-input--error">{invalid}</p>}
        </div>
    );
};

export default BaseCurrencyInput;
